import _ from 'lodash'

export const getError = (httpError, reserviceError) => {
  if (httpError) {
    const httpCode = _.get(httpError, 'cause.code')
    const httpMessage = _.get(httpError, 'message')
    return {
      code: httpCode,
      message: httpMessage
    }
  }

  const isReserviceError = _.get(reserviceError, 'error', false)
  if (isReserviceError) {
    const error = _.get(reserviceError, 'payload.errorData.error[0]')
    const reserviceErrorCode = _.get(
      error,
      'code',
      _.get(error, 'debugError.code')
    )
    const reserviceErrorParsedMessage = _.get(
      error,
      'message',
      _.get(error, 'debugError.message')
    )
    return {
      code: reserviceErrorCode,
      message: reserviceErrorParsedMessage
    }
  }

  return null
}

export const throwIfError = (errors = {}, customMessage) => {
  const { httpError, reserviceError } = errors
  const parsed = getError(httpError, reserviceError)
  if (!parsed) {
    return
  }

  throw new Error(customMessage ?? parsed.message ?? '網路請求失敗', {
    cause: { code: parsed.code, error: httpError || reserviceError }
  })
}
